import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./style.module.css";
import IcSetaDireita from "../Svg/IcSetaDireita";

export default function Breadcrumb(props) {
  const { breadcrumb } = props;
  return (
    <div className={styles.breadcrumb}>
      <NavLink to="/dashboard">Painel</NavLink>
      {breadcrumb?.map((__link, __link_i) => (
        <span key={`breadcrumb-${__link_i}`}>
          {!!__link.label && (
            <>
              <span className={styles.arrow}>
                <IcSetaDireita />
              </span>
              {__link.url ? (
                <NavLink to={__link.url}>{__link.label}</NavLink>
              ) : (
                <span className={styles.title}>{__link.label}</span>
              )}
            </>
          )}
        </span>
      ))}
    </div>
  );
}
